import { all } from 'redux-saga/effects'

import { authSaga } from './auth/operations'

export function* dataSaga() {
  yield all([authSaga()])
}
